import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
// Import translations
import enTranslation from './locales/en.json'
import jaTranslation from './locales/ja.json'
import esTranslation from './locales/es.json'
import deTranslation from './locales/de.json'
import arTranslation from './locales/ar.json'
import heTranslation from './locales/he.json'
import zhTranslation from './locales/zh.json'
// Initialize i18next
i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        translation: enTranslation,
      },
      ja: {
        translation: jaTranslation,
      },
      es: {
        translation: esTranslation,
      },
      de: {
        translation: deTranslation,
      },
      ar: {
        translation: arTranslation,
      },
      he: {
        translation: heTranslation,
      },
      zh: {
        translation: zhTranslation,
      },
    },
    fallbackLng: 'en',
    debug: process.env.NODE_ENV === 'development',
    interpolation: {
      escapeValue: false, // React already safes from XSS
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
    },
    react: {
      useSuspense: false,
    },
  })
export default i18n
